<template lang="pug">
  div
    map-heat(@change='onChange' v-if='!isGuest && hasGeoHeatMap' )
    .legend__group(v-if='hasEquidistant' )
      .legend__type
        label.legend__switch.switch
          span.semibold.legend__name Эквидистанта
          input.visually-hidden.switch__input(
            type="checkbox"
            v-model="showEquidistant"
          )
          span.switch__block
      .legend__small-group(v-show="showEquidistant")
        input.input.input_wide(
          type="text"
          v-model="equidistant"
        )
    .legend__group(v-if='hasEquidistantGeo')
      .legend__type
        label.legend__switch.switch
          span.semibold.legend__name Эквидистанта населенного пункта
          input.visually-hidden.switch__input(
            type="checkbox"
            v-model="showEquidistantGeo"
          )
          span.switch__block
      .legend__small-group(v-show="showEquidistantGeo")
        input.input.input_wide(
          type="text"
          v-model="equidistantGeo"
        )
    .legend__group(v-if="hasMapCadastreBorders")
      .legend__type
        label.legend__switch.switch
          span.semibold.legend__name Кадастровые границы
          input.visually-hidden.switch__input(
            type="checkbox"
            v-model="showCadastre"
            @change="toggleCadastre"
          )
          span.switch__block
    .legend__group(v-if='!showCadastre' )
      .legend__type(style="display: block!important")
        .legend__under
          label.legend__label.semibold Подложка
          select.select.legend__select(v-model="rosreestr_view")
            option(value="osm" v-if='hasOsmTile' ) OSM
            option(value="yandex") Яндекс.Карты
            option(value="satellite") Яндекс.Спутник
</template>

<script>
import { REGION_CONFIG } from '@/config/regions'
import hasMixin from '@/mixins/has-mixin'
import mapHeat from '../components/map-heat'

export default {
  name: 'map-mapping-selector',
  components: { mapHeat },
  mixins: [hasMixin],
  props: {
    mappingConfObject: Object,
    selectedMappingObject: [Number, String],
  },
  data() {
    return {
      rosreestrSearch: '',
      rosreestr_view: REGION_CONFIG.rosreestr_view,
      selected: '',
      showEquidistant: false,
      showCadastre: false,
      equidistant: 1000,
      showEquidistantGeo: false,
      equidistantGeo: 1000,
    }
  },
  computed: {
    availableTiles() {
      const arr = {
        yandex: 'yandex',
        satellite: 'satellite',
      }

      if (this.hasOsmTile) {
        arr.osm = 'osm'
      }
      return arr
    },
    isCadasterNumber() {
      return this.rosreestrSearch.match(/\d{2}:\d{2}:\d{1,7}:\d+/g) !== null
    },
    isGuest() {
      return this.$store.getters.isGuest
    },
  },
  watch: {
    selectedMappingObject: 'onSelectedMappingObject',
    showEquidistant: 'onShowEquidistant',
    equidistant: 'setEquidistant',
    rosreestr_view: 'onRosreestrChangeView',
    showEquidistantGeo() {
      this.$emit('showEquidistantGeo', this.showEquidistantGeo)
    },
    equidistantGeo() {
      this.$emit('equidistantGeo', this.equidistantGeo)
    },
  },
  methods: {
    searchRosreestr() {
      if (this.rosreestrSearch.length <= 2) {
        this.$e.warningBox(
          'Введите корректный адрес или кадастровый номер для поиска'
        )
        return
      }
      this.$emitter.emit('searchRosreestr', this.rosreestrSearch)
    },
    onShowEquidistant(value) {
      this.$emit('showEquidistant', value)
    },
    setEquidistant(setEquidistant) {
      this.$emit('setEquidistant', setEquidistant)
    },
    onRosreestrChangeView(value) {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, tile: value },
      })
      this.$emit('rosreestrChangeView', value)
    },
    onSelectedMappingObject(val) {
      this.selected = val
    },
    onChange(value) {
      this.$emit('change', value)
    },
    toggleCadastre(e) {
      this.$emit(
        'rosreestrChangeView',
        e.target.checked ? 'rosreestr_cadastre' : this.rosreestr_view
      )
    },
  },
  mounted() {
    this.$emitter.listen('mapInit', () => {
      if (this.$route?.query?.tile) {
        this.rosreestr_view =
          this.availableTiles[this.$route.query.tile] ??
          REGION_CONFIG.rosreestr_view
      }
    })
    // инициализируем радиус для обычной эквидистанты...
    this.$emit('setEquidistant', this.equidistant)
  },
}
</script>
